import {z} from 'zod';

import type {ApiError} from 'shared/web';

import type {BulkOperationActionCallbackParams} from '../../types/BulkOperationActionCallback';
import {BulkOperationForm} from '../BulkOperationForm/BulkOperationForm';

const BulkOperationConfirmFormSchema = z.object({});

export function BulkOperationConfirmForm(props: {
  action: BulkOperationActionCallbackParams;
  onError: (error: ApiError) => void;
}) {
  return (
    <BulkOperationForm
      action={props.action}
      onError={props.onError}
      experimentalZodSchema={BulkOperationConfirmFormSchema}
      defaultValues={{}}
      toParams={() => null}
    >
      {() => null}
    </BulkOperationForm>
  );
}
